import { useQuery } from "@tanstack/react-query";
import { thcApi } from "./apiClient";

export const useActiveEcosystems = () => {
  return useQuery({
    queryKey: ["active-ecosystems"],
    queryFn: () => thcApi.grantsApp.getActiveEcosystems(),
  });
};
